<template>
  <div id="features" class="block">
    <div class="text-center">
      <div class="component-header">
        <h2>Features</h2>
        <p class="paragraph">
          Prepare students for clinical documentation by incorporating ChartFlow throughout your curriculum.
        </p>
      </div>
      <div>
        <div class="row q-col-gutter-md-xl q-col-gutter-y-md items-stretch">
          <div class="col-md-4">
            <div class="box pink full-height">
              <div class="logo"><img src="/Simulation.svg" height="100" alt="Simulation icon - clock and medical chart"></div>
              <h3>Simulation</h3>
              <p>
                Real-Time Simulation Control enables educators to change the scenario on the fly, pause &amp; fast-forward time, and quickly
                reset patient scenarios between groups of students.
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="box blue full-height">
              <div class="logo"><img src="/Clinical.svg" height="100" alt="Clinical icon - stethoscope and medical cross"></div>
              <h3>Clinical</h3>
              <p>
                Reduce the clinical paperwork you collect by allowing students to complete documentation as part of their assignment.
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="box yellow full-height">
              <div class="logo">
                <img src="/flexible-content.svg" height="100" alt="Classroom icon - book and graduation cap">
              </div>
              <h3>Classroom</h3>
              <p>
                Over 100 pre-built patient scenarios allow you to quickly incorporate a patient’s health record into a lecture, homework
                assignment, or case study review.
              </p>
            </div>
          </div>
        </div>
        <div class="q-mt-xl">
          <q-btn class="see-features bg-secondary text-white text-bold" label="See all features" to="/features" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: "FeatureBanner",
});
</script>
<style scoped>

.block {
  padding: 3rem;
}

.box {
  background-color: #f0f0f0; /* Light gray background for visibility */
  border: 1px solid #ccc; /* Light border */
  border-radius: 60px; /* Rounded corners */
  padding: 4rem 2rem; /* Padding inside the box */
}

.pink {
  background-color: #fffafb;
  border: 2px solid #fdb9c8;
}

.blue {
  background-color: #f8fafc;
  border: 2px solid #bcd1f0;
}

.yellow {
  background-color: #fffef9;
  border: 2px solid #feedb0;
}

.logo {
  display: flex; /* Use flexbox for centering */
  justify-content: center; /* Center the image horizontally */
  align-items: center; /* Center the image vertically */
  margin-bottom: 1rem; /* Add space between the logo and heading */
  width: 100px;
  margin: 0 auto;
}

.see-features {
  border-radius: 30px;
  padding: 8px 6px;
  min-width: 180px;
  min-height: 45px;
}

h3 {
  margin-bottom: 0.5rem; /* Space between h3 and p */
  font-size: 24px;
  line-height: 36px;
}

p {
  margin-top: 0; /* Remove default top margin */
  line-height: 26px; /* Adjust line height for readability */
  font-size: 16px;
}
</style>
